import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Customer_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "12 Jan 2025",
      clientId: "CUST001",
      companyName: "ABC Coal Traders",
      customerType: "Industry",
      gstNo: "36AAACH7409R1Z2",
      contactPerson: "Ramesh Yadav",
      email: "ramesh@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "10 Jan 2025",
      clientId: "CUST002",
      companyName: "Swapnil Coal Traders",
      customerType: "Trader",
      gstNo: "56AGHTC7409R1Z2",
      contactPerson: "Rakesh Yadav",
      email: "ramesh@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "08 Jan 2025",
      clientId: "CUST003",
      companyName: "Tushar Coal Traders",
      customerType: "Mine",
      gstNo: "36AAACH7409R1Z2",
      contactPerson: "Rakesh Patil",
      email: "rakeshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "14 Jan 2025",
      clientId: "CUST004",
      companyName: "Raut Coal Traders",
      customerType: "Power Plant",
      gstNo: "56AGHTC7409R1Z2",
      contactPerson: "Mahesh Patil",
      email: "maheshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "12 Jan 2025",
      clientId: "CUST001",
      companyName: "ABC Coal Traders",
      customerType: "Others",
      gstNo: "36AAACH7409R1Z2",
      contactPerson: "Ramesh Yadav",
      email: "ramesh@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "10 Jan 2025",
      clientId: "CUST002",
      companyName: "Swapnil Coal Traders",
      customerType: "Industry",
      gstNo: "56AGHTC7409R1Z2",
      contactPerson: "Rakesh Yadav",
      email: "ramesh@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "08 Jan 2025",
      clientId: "CUST003",
      companyName: "Tushar Coal Traders",
      customerType: "Trader",
      gstNo: "36AAACH7409R1Z2",
      contactPerson: "Rakesh Patil",
      email: "rakeshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "14 Jan 2025",
      clientId: "CUST004",
      companyName: "Raut Coal Traders",
      customerType: "Mine",
      gstNo: "56AGHTC7409R1Z2",
      contactPerson: "Mahesh Patil",
      email: "maheshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "12 Jan 2025",
      clientId: "CUST001",
      companyName: "ABC Coal Traders",
      customerType: "Power Plant",
      gstNo: "36AAACH7409R1Z2",
      contactPerson: "Ramesh Yadav",
      email: "ramesh@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "10 Jan 2025",
      clientId: "CUST002",
      companyName: "Swapnil Coal Traders",
      customerType: "Others",
      gstNo: "56AGHTC7409R1Z2",
      contactPerson: "Rakesh Yadav",
      email: "rakeshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "12 Jan 2025",
      clientId: "CUST003",
      companyName: "Tushar Coal Traders",
      customerType: "Mine",
      gstNo: "36AAACH7409R1Z2",
      contactPerson: "Rakesh Patil",
      email: "rakeshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
    {
      date: "12 Jan 2025",
      clientId: "CUST004",
      companyName: "Raut Coal Traders",
      customerType: "Power Plant",
      gstNo: "56AGHTC7409R1Z2",
      contactPerson: "Mahesh Patil",
      email: "maheshpatil@abc.com",
      contactNo: "9876543210",
      noOfTests: 12,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Date</th>
                <th>Client ID</th>
                <th>Company Name</th>
                <th>Customer Type</th>
                <th>GST No.</th>
                <th>Contact Person</th>
                <th>Email</th>
                <th>Contact No.</th>
                <th>No. Of Tests</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.clientId}</td>
                  <td>{row.companyName}</td>
                  <td>{row.customerType}</td>
                  <td>{row.gstNo}</td>
                  <td>{row.contactPerson}</td>
                  <td>{row.email}</td>
                  <td>{row.contactNo}</td>
                  <td>{row.noOfTests}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Customer_Report_Table;
